var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFremiumUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1166,
    cy: 22.1166,
    r: 22.1166,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1299_9603",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.0583,
    y: 11.0581,
    width: 22.1166,
    height: 22.1166,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1299_9603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1168 22.1164C21.1032 22.1164 20.2354 21.7554 19.5135 21.0336C18.7917 20.3117 18.4307 19.4439 18.4307 18.4302C18.4307 17.4166 18.7917 16.5488 19.5135 15.8269C20.2354 15.1051 21.1032 14.7441 22.1168 14.7441C23.1305 14.7441 23.9983 15.1051 24.7202 15.8269C25.442 16.5488 25.803 17.4166 25.803 18.4302C25.803 19.4439 25.442 20.3117 24.7202 21.0336C23.9983 21.7554 23.1305 22.1164 22.1168 22.1164ZM14.7446 27.6455V26.9083C14.7446 26.3861 14.879 25.9061 15.1478 25.4684C15.4166 25.0307 15.7737 24.6966 16.2191 24.4663C17.1713 23.9901 18.1389 23.633 19.1219 23.395C20.1048 23.1569 21.1032 23.0379 22.1168 23.0379C23.1305 23.0379 24.1288 23.1569 25.1118 23.395C26.0948 23.633 27.0624 23.9901 28.0146 24.4663C28.46 24.6966 28.8171 25.0307 29.0859 25.4684C29.3547 25.9061 29.4891 26.3861 29.4891 26.9083V27.6455C29.4891 28.1524 29.3086 28.5862 28.9477 28.9472C28.5867 29.3081 28.1528 29.4886 27.646 29.4886H16.5877C16.0808 29.4886 15.647 29.3081 15.286 28.9472C14.9251 28.5862 14.7446 28.1524 14.7446 27.6455Z",
    fill: "#7DA7B9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFremiumUsers);
export default __webpack_public_path__ + "static/media/fremium-users.ce03dbb28b7f8fef769de0e292b9981b.svg";
export { ForwardRef as ReactComponent };